import { render, staticRenderFns } from "./VRichText.vue?vue&type=template&id=54a8eca6"
import script from "./VRichText.vue?vue&type=script&lang=ts"
export * from "./VRichText.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports